import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  class: "backdrop",
  role: "presentation"
}
const _hoisted_2 = {
  key: 0,
  class: "loading-term"
}
const _hoisted_3 = {
  class: "sr-only",
  role: "status",
  "aria-live": "assertive",
  "aria-atomic": "true"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Square = _resolveComponent("Square")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Square),
    (_ctx.loadingTermValue)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.loadingTermValue), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.announcedValue), 1)
  ]))
}